<script>
export default {
  name: "ProjectCollectionTemplateCategorySave",
  data(){
    return{
      formData: {
        id: null,
        is_active: 1
      },
      list: [],
      visible: false,
      disabled: false
    }
  },
  methods:{
    show(data) {
      if (data) {
        this.formData = data
      }else {
        this.formData = {
          id: null,
          is_active: 1
        }
      }
      this.visible = true
      this.disabled = false
      this.getList()
    },
    handleDialogClose() {
      this.visible = false
      this.formData = {
        id: null,
        is_active: 1
      }
      this.$emit('close')
    },
    getList(p) {
      if(p)this.page = p
      this.$myhttp.get('butler/ProjectCollectionTemplateCategory/getList', {}).then(resp => {
        let res = resp.data
        if(res.code == 1) {
          this.list = [...[
            {
              id: 0,
              name: '无',
              children: []  // 没有子节点
            }
          ], ...res.data.list]
        }
      })
    },
    handleSortInput(value) {
      this.formData.sort_order = value.replace(/\D/g, '')
    },
    handleSubmit() {
      this.disabled = true
      this.$myhttp.post('butler/ProjectCollectionTemplateCategory/save', this.formData).then(resp => {
        let res = resp.data
        this.disabled = false
        if(res.code == 1) {
          this.$message.success(res.msg)
          this.handleDialogClose()
        }else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<template>
  <el-dialog
    :visible.sync="visible"
    :title="formData.id ? '编辑模版分类' : '创建模版分类'"
    append-to-body
    destroy-on-close
    :close-on-click-modal="false"
    @close="handleDialogClose"
    width="60%"
  >
    <el-form ref="form" :model="formData" label-width="120px" size="mini" style="margin-right: 20px;">
      <el-form-item label="父级分类">

        <el-cascader
          v-model="formData.parent_id"
          :options="list"
          :props="{
            label: 'name',
            value: 'id',
            children: 'children',
            checkStrictly: true,
            emitPath: false
          }"
          placeholder="请选父级分类"
          clearable
          style="width: 100%"
        >
          <template slot-scope="{ data }">
            <span>{{ data.name }}</span>
          </template>
        </el-cascader>
      </el-form-item>
      <el-form-item label="分类名称">
        <el-input v-model="formData.name" placeholder="分类名称"></el-input>
      </el-form-item>
      <el-form-item label="排序权重">
        <el-input v-model="formData.sort_order" placeholder="排序权重 (数字越小越靠前)" @input="handleSortInput"></el-input>
      </el-form-item>
      <el-form-item label="分类描述">
        <el-input type="textarea" v-model="formData.description" placeholder="分类描述"></el-input>
      </el-form-item>
      <el-form-item label="是否启用">
        <el-radio-group v-model="formData.is_active">
          <el-radio :label="0" size="large">隐藏</el-radio>
          <el-radio :label="1" size="large">显示</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button size="small" @click="handleDialogClose">取消</el-button>
      <el-button size="small" type="primary" @click="handleSubmit" :disabled="disabled">确定</el-button>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/projectCollectionTemplate/category/save.vue